import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetService} from '../../../../../../../domain/widget/service/widget.service';
import {SafeSubscriberDirective} from '../../../../../../../application/app-context/safe-subscriber.directive';
import {WidgetDetail} from '../../../../../../../domain/widget/model/widget-detail';
import {BankProposal} from '../../../../../../../domain/bank-proposal/bank-proposal';
import {TranslateService} from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import {Chart} from 'angular-highcharts';
import {HomeAssistanceListDialogComponent} from '../../../../assistance/list-dialog/home-assistance-list-dialog.component';
import {UserContextService} from '../../../../../../../application/app-context/user-context/user-context.service';
import {DomainUrlService} from '../../../../../../../application/config/domain-url.service';
import {ApplicationName} from '../../../../../../../domain/core/model/aplication-name.enum';
import {MatDialog} from '@angular/material/dialog';


@Component({
             selector: 'app-widget-bankproposal-small',
             templateUrl: './home-dashboard-widget-bankproposal-small.component.html',
             styleUrls: ['./home-dashboard-widget-bankproposal-small.component.scss']
           })
export class HomeDashboardWidgetBankproposalSmallComponent extends SafeSubscriberDirective implements OnInit {

  @Input() widget: WidgetDetail | undefined;
  @Input() bankProposalData: BankProposal | undefined;
  @Input() dashboardId: number | undefined;

  chart: Chart;
  currentMaturity: number;

  @Output() actionEvent = new EventEmitter<string>();

  isAssistanceEnabled: boolean;
  insitoAccountId: number;

  constructor(private widgetService: WidgetService,
              private translateService: TranslateService,
              public matDialog: MatDialog,
              private userContextService: UserContextService,
              private domainUrlService: DomainUrlService) {
    super();
  }

  ngOnInit(): void {
    this.currentMaturity = this.bankProposalData.bankProposalStatisticsForMaturities[0].maturity;
    this.loadChart();
    const userContext = this.userContextService.getUserContext();
    this.isAssistanceEnabled = userContext.isAssistanceEnabled;
    this.insitoAccountId = userContext.getCurrentAccount().applications.find(application => application.targetApp === ApplicationName.INSITO && application.hasAccess).accountSynchId;
  }

  previousMaturity(): void {
    const currentIndex = this.bankProposalData.bankProposalStatisticsForMaturities.map(d => d.maturity).indexOf(this.currentMaturity);
    this.currentMaturity = this.bankProposalData.bankProposalStatisticsForMaturities[currentIndex - 1].maturity;
    this.loadChart();
    this.actionEvent.emit('widget.amplitude.carousel-use');
  }

  nextMaturity(): void {
    const currentIndex = this.bankProposalData.bankProposalStatisticsForMaturities.map(d => d.maturity).indexOf(this.currentMaturity);
    this.currentMaturity = this.bankProposalData.bankProposalStatisticsForMaturities[currentIndex + 1].maturity;
    this.loadChart();
    this.actionEvent.emit('widget.amplitude.carousel-use');
  }

  isLastMaturiy(): boolean {
    return this.bankProposalData.bankProposalStatisticsForMaturities.map(d => d.maturity).indexOf(this.currentMaturity)
           === this.bankProposalData.bankProposalStatisticsForMaturities.length
           - 1;
  }

  isFirstMaturiy(): boolean {
    return this.bankProposalData.bankProposalStatisticsForMaturities.map(d => d.maturity).indexOf(this.currentMaturity) === 0;
  }

  redirectToAssistance(): void {
    this.actionEvent.emit('widget.bank-proposal.discover-opportunity');
    this.matDialog.open(HomeAssistanceListDialogComponent, {
      data: {
        searchText: this.translateService.instant('widget.bank-proposal.search-opportunity')
      },
      height: '100%',
      width: '75%',
      position: {
        right: '0'
      }
    });
  }

  redirectToInsitoIfHasAccessOrElseBankProposal(): void {
    if (this.insitoAccountId !== undefined) {
      window.location.href = `${this.domainUrlService.getInsitoUrl()}?accountId=${this.insitoAccountId}&redirectLink=analysesEtSyntheses`;
      return;
    }
    window.location.href = `${this.domainUrlService.getBankProposalUrl()}/dashboard`;
  }

  private loadChart(): void {
    const spec = {
      credits: {
        enabled: false
      },
      chart: {
        type: 'column',
        spacing: [1, 1, 1, 1],
        marginTop: 8,
        spacingTop: 8,
        spacingBottom: 0,
        marginBottom: 10,
        plotBorderColor: '#6a7480',
        backgroundColor: '#ffffff',
        plotBorderWidth: 0,
        style: {
          fontFamily: 'Arial, Helvetica, sans-serif',
          'font-family': 'Arial, Helvetica, sans-serif'
        }
      },
      colors: ['#1c3966', '#e95053', '#f59700', '#008CBA', '#9F1BB7'],
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      accessibility: {
        announceNewData: {
          enabled: true
        }
      },
      xAxis: {
        className: 'widget-highcharts-yaxis',
        title: {
          text: null
        },
        type: 'category',
        gridLineColor: '#CCCCCC',
        gridLineDashStyle: 'Dash',
        gridLineWidth: 0,
        lineColor: '#CCCCCC',
        tickPosition: 'inside',
        tickmarkPlacement: 'on',
        tickWidth: 0,
        tickColor: '#CCCCCC',
        labels: {
          enabled: true,
          padding: 1,
          y: 9,
          style: {
            color: '#000000',
            fontSize: '9px',
            fontWeight: 'normal'
          }
        },
        style: {
          fontFamily: 'Arial, Helvetica, sans-serif',
          'font-family': 'Arial, Helvetica, sans-serif'
        }
      },
      yAxis: {
        className: 'widget-highcharts-yaxis',
        title: {
          text: null
        },
        gridLineColor: '#CCCCCC',
        gridLineDashStyle: 'Dash',
        gridLineWidth: 1,
        lineColor: '#CCCCCC',
        lineWidth: 1,
        labels: {
          x: -8,
          format: '{value:,.2f}%',
          style: {
            color: '#37404E',
            fontSize: '9px',
            fontWeight: 'normal'
          }
        },
        tickPosition: 'inside',
        tickWidth: 0,
        tickLength: 0,
        tickColor: '#6a7480',
        tickAmount: 4,
        style: {
          fontFamily: 'Arial, Helvetica, sans-serif',
          'font-family': 'Arial, Helvetica, sans-serif'
        }
      },
      legend: {
        enabled: false,
        itemStyle: {
          lineHeight: '12px',
          fontSize: '10px',
          color: '#6A7480'
        },
        style: {
          fontFamily: 'Arial, Helvetica, sans-serif',
          'font-family': 'Arial, Helvetica, sans-serif'
        }
      },
      plotOptions: {
        column: {
          borderRadiusTopLeft: 5,
          borderRadiusTopRight: 5,
          borderWidth: 0,
          maxPointWidth: 5,
          dataLabels: {
            style: {
              fontWeight: 'normal',
              fontSize: '10px'
            },
            enabled: true,
            format: '{point.y:.2f}%'
          }
        }
      },
      tooltip: {
        formatter(): string {
          return this.points.reduce((s, point) => {
            return '<span style="font-size:11px">' + point.series.name + '</span><br>' +
                   '<span style="color:' + point.point.color + '">' + point.point.name + ' (' + point.point.text + ')</span>: <b>'
                   + point.point.formattedAmount + ' %</b><br/>';
          }, '<b>' + this.x + '</b>');
        },
        shared: true,
        outside: true
      },
      series: [
        {
          type: 'column',
          name: this.translateService.instant('widget.bank-proposal.small.seriename', {maturity: this.currentMaturity}),
          maxPointWidth: 20,
          pointWidth: 20,
          data: this.dataSerie()
        }
      ]
    };
    this.chart = new Chart(spec as Highcharts.Options);
  }

  private dataSerie(): any {
    const data = this.bankProposalData.bankProposalStatisticsForMaturities.find(d => d.maturity === this.currentMaturity);
    const serie = [];
    if (data.bestFixedRate != null) {
      serie.push({
                   name: this.translateService.instant('widget.bank-proposal.small.fixed-rate'),
                   color: '#92BC4F',
                   y: data.bestFixedRate,
                   formattedAmount: data.bestFixedRate.toFixed(2),
                   text: this.translateService.instant('widget.bank-proposal.fixedRateInformation')
                 });
    }
    if (data.bestFloatingMarge != null) {
      serie.push({
                   name: this.translateService.instant('widget.bank-proposal.small.floating-rate'),
                   color: '#1A87A9',
                   formattedAmount: data.bestFloatingMarge.toFixed(2),
                   y: data.bestFloatingMarge,
                   text: this.translateService.instant('widget.bank-proposal.floatingRateInformation')
                 });
    }
    return serie;
  }
}
